import { render, staticRenderFns } from "./SalesRoot.vue?vue&type=template&id=3510f873&scoped=true&web=true&"
import script from "./SalesRoot.vue?vue&type=script&lang=ts&"
export * from "./SalesRoot.vue?vue&type=script&lang=ts&"
import style0 from "./SalesRoot.vue?vue&type=style&index=0&id=3510f873&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3510f873",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
